import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Button, ExternalLinkButton } from 'components/styled/button'
import { mapLanguageToPageProps } from 'interview/i18n'
import Layout from 'interview/components/layout'
import Html from 'components/html/html'
import FeedbackPulse from 'components/feedback-pulse'
import { Body, H3 } from 'components/styled/typography'
import { Flex } from 'components/styled/containers/flex'
import { PositionType } from 'types'
import { I18nPageType } from 'interview/i18n-types'
import { Box } from 'components/styled/containers/box'

interface FinishedComponentProps {
  i18n: I18nPageType
  interview: PositionType
  candidate: { uuid: string }
  showSurvey?: boolean
  loadingReopen?: boolean
  isPreview?: boolean
  onReopenInterview?: () => void
}

const StyledContainer = styled(Flex)`
  text-align: center;
`

export function Finished({
  i18n,
  interview,
  candidate,
  showSurvey = false,
  loadingReopen = false,
  isPreview = false,
  onReopenInterview,
}: FinishedComponentProps) {
  const renderReopen = () => {
    const company = interview && interview.company
    const companyData = company && {
      companyId: company._id,
      companyName: company.name,
    }

    if (candidate.uuid) {
      return (
        <StyledContainer flexDirection="column" alignItems="center">
          <Body mt="s12" mb="s24">
            {i18n.finished.reopenDescription}
          </Body>
          <Button
            loading={loadingReopen}
            variant="secondary"
            icon="lock_open"
            text={i18n.finished.reopenButtonText}
            onClick={onReopenInterview}
            event={
              isPreview
                ? undefined
                : {
                    locationId: 'finishedPage',
                    id: 'reopenInterviewButton',
                    properties: {
                      candidateUuid: candidate.uuid,
                      ...companyData,
                    },
                  }
            }
          />
        </StyledContainer>
      )
    }
    return (
      <StyledContainer mt="s12" flexDirection="column">
        <Html
          html={i18n.finished.descriptionsupport(
            `<a href='mailto:${i18n.supportLink}'>${i18n.supportLink}</a>`
          )}
        />
      </StyledContainer>
    )
  }

  // TODO is this url needed if preview?

  const feedbackUrl =
    interview.type === 'sequenced'
      ? i18n.finished.timedUrl
      : i18n.finished.regularUrl

  return (
    <Layout size="small" jobOpening={isPreview ? interview : undefined}>
      <StyledContainer mt="s40" flexDirection="column" alignItems="center">
        <H3>{i18n.finished.title}</H3>
        <Body mt="s24">{i18n.finished.description1}</Body>
        {interview.type !== 'sequenced' && renderReopen()}
        {interview._id && (
          <FeedbackPulse
            position={interview}
            company={interview.company}
            isPreview={isPreview}
          >
            {showSurvey && (
              <StyledContainer flexDirection="column" alignItems="center">
                <Body>{i18n.finished.descriptionfeedback}</Body>
                <Box mt="s16">
                  <ExternalLinkButton
                    // @ts-ignore
                    className="survey-button"
                    icon="poll"
                    target="_blank"
                    href={feedbackUrl}
                    text={i18n.finished.feedbackbutton}
                  />
                </Box>
              </StyledContainer>
            )}
          </FeedbackPulse>
        )}
      </StyledContainer>
    </Layout>
  )
}

export default connect(mapLanguageToPageProps())(Finished)
